(function () {
    'use strict';

    angular
        .module('app')
        .factory('ToolbarService', ToolbarService);

    ToolbarService.$inject = ['$http'];

    function ToolbarService($http) {
        var service = {
            Hello: Hello,
            GetShowViewCommand: GetShowViewCommand
    };
        return service;

        // Call the Assign command with a Selection List.
        function Hello() {
            alert('Hello');
        }

        function GetShowViewCommand(libId, fileId, majRev, minRev) {
            var request = $http.get("../Synergis.WebApi/api/SelectionCommand/IsAllowedToView/" + libId + "/" + fileId + "/" + majRev + "/" + minRev);
            return request;
        }


    }
})();